import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthSettingsService } from 'baseflow-auth';
import { Observable, switchMap } from 'rxjs';
import { take } from 'rxjs/operators';

import { TenantService } from '../services';

@Injectable({ providedIn: 'root' })
export class TenantInterceptor implements HttpInterceptor {
    private tenantService = inject(TenantService);
    private readonly authSettings = inject(AuthSettingsService);

    public intercept(req: HttpRequest<HttpEvent<unknown>>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const tenant = this.tenantService.getActiveTenant();
        if (!tenant) {
            return next.handle(req);
        }

        return this.authSettings.authSettings.pipe(
            take(1),
            switchMap((settings) => {
                if (!req.url.includes(settings.keycloakUrl)) {
                    req = req.clone({ headers: req.headers.set('OneGo-Tenant', tenant.id) });
                }
                return next.handle(req);
            })
        );
    }
}
